import { toast } from "react-toastify";
import { searchEventPublic } from "../../../services/ContactPublicService";
import { useAxiosInstance } from "../../../services/Interceptor";
import { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function InputSearch({ setEvents, setLoading, loading }) {
  const [query, setQuery] = useState("");
  const apiInstance = useAxiosInstance();

  const handleSearchClick = async (e) => {
    e.preventDefault();
    fetchEvents(query);
  };

  const fetchEvents = async (q) => {
    setLoading(true);
    try {
      const trimmedQuery = q.trim();
      const data = await searchEventPublic(apiInstance, trimmedQuery);

      if (Array.isArray(data) && data.length > 0) {
        setEvents(data);
        if (trimmedQuery) toast.success("Events successfully found!");
      } else {
        setEvents([]);
        toast.info(
          trimmedQuery
            ? "No events found for this search."
            : "No events available.",
          {
            autoClose: false,
            closeOnClick: true,
          },
        );
      }
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <form
        className="flex items-center max-w-xl mx-auto"
        onSubmit={handleSearchClick}
      >
        <div className="relative w-full">
          <input
            type="search"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              if (e.target.value.trim() === "") {
                fetchEvents("");
              }
            }}
            className="border border-neutral-500 text-white bg-neutral-500 text-sm rounded-lg block w-full ps-4 p-2.5"
            placeholder="Search Events..."
            required
          />
          <button
            type="submit"
            className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-neutral-700 rounded-e-lg hover:bg-neutral-400"
          >
            <FontAwesomeIcon icon={faSearch} className="h-5 w-5" />
            <span className="sr-only">Search</span>
          </button>
        </div>
      </form>
      {loading && (
        <div className="flex justify-center mt-5">
          <LoadingSpinner />
        </div>
      )}
    </div>
  );
}

export default InputSearch;
